"use client";

import { useState, useRef, FormEvent } from "react";
import ConsoleLink from "@/components/ui/console-link";

export default function EmailSignup() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const emailRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!emailRef.current?.value || isSubmitting) return;
    
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('email', emailRef.current.value);
      formData.append('l', 'ee575c18-dace-4477-bb9f-f3aa9dc00501');
      
      const response = await fetch('https://listmonk.limrun.com/subscription/form', {
        method: 'POST',
        body: formData,
      });
      
      if (response.ok) {
        setIsSubmitted(true);
      } else {
        console.error('Subscription error:', response.statusText);
      }
    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-[#f9f7f6] flex items-center justify-center px-4 z-50">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl sm:text-5xl font-medium text-slate-900 mb-4">
            The first AI-native<br />cloud
          </h1>
          <p className="text-lg text-gray-600 mb-2">
            Supercharge your AI agent with browsers, mobile emulators, sandboxes and more.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border p-8">
          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="email"
                  id="email"
                  name="email"
                  ref={emailRef}
                  required
                  placeholder="Enter your email address"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#175134] focus:border-transparent text-base"
                />
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-4 py-3 bg-[#175134] text-white font-medium rounded-md hover:bg-[#0f3a26] transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-base"
              >
                {isSubmitting ? "Signing up..." : "Sign up for private beta"}
              </button>
            </form>
          ) : (
            <div className="text-center py-4">
              <div className="mb-4 flex justify-center">
                <svg 
                  className="w-16 h-16 text-green-500" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth="2" 
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-slate-900">Thank You!</h3>
              <p className="text-gray-600">
                Once we're ready for you, we'll let you in!
              </p>
            </div>
          )}
        </div>

        <p className="text-center text-sm text-gray-500 mt-6">
          Limrun, the first AI-native cloud platform.
        </p>
      </div>
    </div>
  );
} 